import { Box, Fab, styled } from '@mui/material';

export const ScrollToTopButtonWrap = styled(Box)({
	position: 'fixed',
	bottom: 32,
	right: 32,
	zIndex: 1,
});

export const ScrollToTopFab = styled(Fab)({
	borderRadius: '10px',
	background: '#FFFFFFB2',
	boxShadow: 'none',
});
